import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import EmpHeader from "./emp_components/EmpHeader";
import SunderNursery from "./emp_components/SunderNursery";
import ExploreAllEpisodes from "./emp_components/ExploreAllEpisodes";
import EmpoweringEngagingLearning from "./emp_components/EmpoweringEngagingLearning";
import NoGadgetHour from "./emp_components/NoGadgetHour";
import Footer from "./emp_components/Footer";
import { apiRequest, API_URL } from "../utils/Helper";
import ReelSlider from "./emp_components/ReelSlider";
import SharePopup from "../common/Sharepopup";

const Empowering = () => {
  const [headerData, setHeaderData] = useState();
  const [episodeData, setEpisodeData] = useState();
  const [shortsData, setShortsData] = useState();
  const [showPopup, setShowPopup] = useState(false);
  const [reeldata, setReeldata] = useState();
  const [popUpdata, setPopUpdata] = useState();

  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  const [link, setLink] = useState("");
  const [quote, setQuote] = useState("");
  const [Type, setType] = useState("");
  const [twittermessage, setTwittermessage] = useState("");
  const [shareType, setShareType] = useState("");
  const [activeIndex, setActiveIndex] = useState(null);
  const [activeIndexForSlide, setActiveIndexForSlide] = useState(0);

  const handleclick = (index, list, indexforslide, type) => {
    console.log(type);
    setShowPopup(true);
    handleShow();
    setActiveIndex(index);
    setActiveIndexForSlide(indexforslide);
    setPopUpdata(list);
    setType(type);
  };

  const handleShareData = (link, quote, twitterMessage, shareType) => {
    setLink(link);
    setQuote(quote);
    setTwittermessage(twitterMessage);
    setShareType(shareType);
  };

  const handleBack = () => {
    setShowPopup(false);
    setShow(false);
  };

  useEffect(() => {
    const fetchHomeData = async () => {
      try {
        const response = await apiRequest(API_URL);
        if (response && response.data.length > 0) {
          setHeaderData(response?.data[0]);
          setEpisodeData(response?.data[1]?.data);
          setShortsData(response?.data[2]?.data);
          setReeldata(response?.data[0]?.parikshadata?.shorts);
        }
      } catch (error) {
        console.error("Failed to fetch episode data:", error);
      }
    };

    fetchHomeData();
  }, []);

  return (
    <>
      <EmpHeader />
      {headerData && (
        <SunderNursery
          headerData={headerData}
          handleclick={handleclick}
          handleShareData={handleShareData}
        />
      )}
      {episodeData && shortsData && (
        <ExploreAllEpisodes
          episodeData={episodeData}
          shortsData={shortsData}
          handleclick={handleclick}
          handleShareData={handleShareData}
        />
      )}
      <EmpoweringEngagingLearning />
      {/* <NoGadgetHour /> */}
      <Footer />

      <SharePopup
        link={link}
        quote={quote}
        twittermessage={twittermessage}
        shareType={shareType}
      />

      <Modal className="vshorts_pop" show={show} onHide={handleClose} centered>
        <Modal.Body>
          {showPopup && popUpdata && Type && popUpdata.length > 0 && (
            <ReelSlider
              reel={popUpdata}
              showpopup={showPopup}
              handleShareData={handleShareData}
              handleBack={handleBack}
              activeIndex={activeIndex}
              activeIndexForSlide={activeIndexForSlide}
              Type={Type}
            />
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Empowering;
